import { Col, Row } from 'react-styled-flexboxgrid';

import PageHeadline from '@/components/ui/elements/PageHeadline';
import ResponsiveGrid from '@/components/ui/ResponsiveGrid';
import breakpoint from 'styled-components-breakpoint';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const BlogPostGrid = styled(ResponsiveGrid)`
  background-color: ${theme('colors.lightGray')};
  padding-top: 2rem;
  padding-bottom: 4rem;
`;

const Title = styled(PageHeadline)`
  text-align: center;
  margin-bottom: 4rem;
`;

const HeroResponsiveGrid = styled(ResponsiveGrid)`
  ${breakpoint('xs', 'md')`
    padding-right: 0;
    padding-left: 0;
  `}
`;

const HeroImageRow = styled(Row)`
  ${breakpoint('xs', 'md')`
    padding-right: 0;
    padding-left: 0;
    margin-left: 0;
    margin-right: 0;
  `}
`;

const HeroImageCol = styled(Col)`
  ${breakpoint('xs', 'md')`
    padding-right: 0;
    padding-left: 0;
    margin-left: 0;
    margin-right: 0;
  `}
`;

const PostContentRow = styled(Row)`
  padding-top: 4rem;
  ${breakpoint('xs', 'md')`
    padding-bottom: 2rem;
  `}
  ${breakpoint('md')`
    padding-bottom: 6rem;
  `}
`;

const PostContentCol = styled(Col)`
  margin-top: 40;

  figure {
    margin-bottom: 1.66rem;
  }
`;

export { BlogPostGrid, Title, HeroResponsiveGrid, HeroImageRow, HeroImageCol, PostContentRow, PostContentCol };
